function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t#plant1 .st0{display:none;}\n\t#plant1 .st1{display:inline;opacity:0.2;fill:none;stroke:#58595B;stroke-miterlimit:10;}\n\t#plant1 .st2{display:inline;opacity:0.2;fill:none;stroke:#58595B;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st3{display:inline;opacity:0.2;fill:none;stroke:#D3B986;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st4{display:inline;opacity:0.2;fill:none;stroke:#58595B;stroke-width:0.5;stroke-miterlimit:10;}\n\t#plant1 .st5{display:inline;opacity:0.5;fill:none;stroke:#58595B;stroke-width:0.5;stroke-miterlimit:10;}\n\t#plant1 .st6{display:inline;fill:none;stroke:#58595B;stroke-width:0.5;stroke-miterlimit:10;}\n\t#plant1 .st7{display:inline;opacity:0.4;fill:none;stroke:#58595B;stroke-miterlimit:10;}\n\t#plant1 .st8{display:inline;opacity:0.4;fill:none;stroke:#58595B;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st9{display:inline;opacity:0.4;fill:none;stroke:#D3B986;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st10{display:inline;opacity:0.4;fill:none;stroke:#58595B;stroke-width:0.5;stroke-miterlimit:10;}\n\t#plant1 .st11{opacity:0.7;fill:none;stroke:#58595B;stroke-miterlimit:10;}\n\t#plant1 .st12{opacity:0.7;fill:none;stroke:#58595B;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st13{opacity:0.7;fill:none;stroke:#D3B986;stroke-width:0.25;stroke-miterlimit:10;}\n\t#plant1 .st14{opacity:0.7;fill:none;stroke:#58595B;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x33_rd_layer",
  className: "st0"
}, React.createElement("path", {
  id: "XMLID_211_",
  className: "st1",
  d: "M244.9,288.3c0,0-3.7-47.5-6.5-48.1c0,0-19.5,1.6-26.1-14.8s-8.1-22.3-18.6-18.5 c0,0,16.5-12.1,28.2-1.1c0,0,0.1-2-0.5-3.7c0,0,12.4,3.4,15.2,15.6c0,0,1.2-2.5,0.7-5.9c0,0,6.7,12.3,3.5,26.3 c0,0,11,31.2,11.9,45.3"
}), React.createElement("path", {
  id: "XMLID_210_",
  className: "st2",
  d: "M245.9,291.7c0,0-4-48.8-10.6-52.5c-6.6-3.7-14.3-1.5-22.9-13.9s-8.1-20.3-18.6-18.5 s19.5-17.7,38-1s11.2,38.5,11.2,38.5s6.6,29.7,6.3,42.6"
}), React.createElement("path", {
  id: "XMLID_209_",
  className: "st2",
  d: "M243.4,288.5c0,0,0.1-46.5-8.2-49.3c-8.2-2.8-17.6,2-22.9-13.9s-0.5-37.4,13.8-21.2 c0.3,0.3,0.6,0.7,0.9,1c13.1,14.9,6.8,8.5,9.7,16c3,7.7,1.2,11.9,4.7,22.2c3.5,10.3,8.6,14.4,9.1,27.2c0.6,12.8,0.3,10.5-3.7-6.4 s2.9-12.5-6-26c-8.9-13.5-4.2-26.3-12.4-28.3c-8.2-2-16.3-11.2-21.5-8.5c-5.2,2.7-13.4,4.2-10.7,5.7c2.7,1.4,10.7,6.3,12.8,13.2 c2.1,6.9,25.4,14.5,28.5,17.9c3.1,3.3,5,46.9,4.3,50.6"
}), React.createElement("path", {
  id: "XMLID_208_",
  className: "st3",
  d: "M189.8,207.9c0,0,0.7-0.2,1.9-0.5c4.6-1,16.6-2.2,23.7,9.3c8.9,14.5,7.2,19.2,15.8,23 c8.6,3.8,10.1,17.1,11.9,35.4s3.1-10.4-0.9-33.2s-9.2-59.1-51.6-34.2"
}), React.createElement("path", {
  id: "XMLID_207_",
  className: "st3",
  d: "M189.5,205.8c0,0,8.9-4.6,14.5,5.4c1.8,3.1,2.8,5.5,3.8,7.6c2.2,4.6,4,7.6,11.9,13 c0.7,0.5,1.3,0.9,1.9,1.2c8.9,5.4,4.6-2.6,13.1,9.1c9,12.4,9.7,8.8,10.5,21.9c0.7,13.1-0.2,18.8,0.1,22.1c0.3,3.3-1.9,4.5-3.3-4.1 c-1.4-8.5,1.5-5.5-0.6-16c-2.2-10.4,0.9-6-3.7-16.1c-4.6-10.1,0.9-3.5-6.5-10.4c-7.5-6.9-7.5-0.9-18.9-10.3c0,0-9-24-20.6-21.9"
}), React.createElement("path", {
  id: "XMLID_206_",
  className: "st2",
  d: "M198.3,204.1c0,0,11.9-1,21.9,11.4s2.9,1.1,13.2,17.3c10.3,16.2,12.2,15,14.7,32.4 c2.5,17.5-9-33.7-18.8-44.6C219.3,209.8,205.7,202,198.3,204.1z"
}), React.createElement("path", {
  id: "XMLID_205_",
  className: "st4",
  d: "M217.2,213.1c11.5,17.3,28.9,40.3,28.1,39.2s6.5-35.7-18-42.8s-15.4-10.3-36.1-6 c0,0,1,0.5,2.6,1.3c5.7,2.9,18.8,10.4,22,18.2c4,10-2.4,9.8,8.3,14.5c10.7,4.7,12-1.2,16.2,11.6s7.5,11.4,6.5,26s2.2,24.3,1.8,10.7 s10.4,16.7,1.4-13.7c-9-30.4-2.8-39.5-10.9-54.7c-8.2-15.2-15.7-18.1-32.4-13.8"
}), React.createElement("path", {
  id: "XMLID_204_",
  className: "st1",
  d: "M255.6,204.3c0,0,22.7-57.1,16.3-87.3c0,0-30-6.9-37-20.1s-4.8-45.9-29.3-42.3 c0,0,16.3-17.1,47.1,2.1c0,0,1.8-6.4-1.2-8.3c0,0,19.6,12.7,18.5,28.1c0,0,3.5-3.3,3.1-9.3c0,0,10.3,14.3,4,43c0,0,2,20.9,0.8,26.3 c0,0,13.1-23.8,20.5-27.4c0,0,9.1-28,21.5-30.4c0,0-3.5,4.8-3.6,8.9c0,0,13.9-17.1,28.9-13.2c0,0-4.5,2.8-5.1,5 c0,0,31.3-3.2,38.8,18.8c0,0-9.2-12-22.4,0.6s-23.3,30.3-52.9,15.8c0,0-3.5,0-5.9,3.6s-17.5,15.7-29,74.6"
}), React.createElement("path", {
  id: "XMLID_203_",
  className: "st2",
  d: "M263.4,205c0,0,15.8-78.8,39.7-88.5c0,0,7.8,8,26.8-1.1c19.1-9.1,34.8-34.3,42.6-27.1 c7.8,7.2-26.8-28.1-52.6-9.5c-25.8,18.6-25.5,39.1-30.4,42.8c-4.8,3.7-17.2,15.9-19.4,29.7c-2.2,13.8-11.6,74.5-7.2,50.5 c4.4-24,19.8-68.1,19-82.9s-8.7-88.7-72.2-64.5c0,0,61.5-26.4,69.6,58.8s-20.3,99.6-20.3,99.6s20-80.3,37.3-97.9 s8.3-38.4,39.6-42.9C367.2,67.4,378,102,378,102s0.3-24-22.1-0.9c-22.4,23.1-37.3,20.5-52.4,13.4c-15-7.1-42.9,86.6-42.9,86.6 s17.1-70.7,11.3-84.1c-3-6.9-10.4-5.2-18.7-7.4c-7.7-2-16.2-7.4-22.5-26.3c-13.2-39.1-28.9-27.9-28.9-27.9s15.8-6.8,25.1,13.9 c9.3,20.8,23.7,34.9,34.5,39.1c10.8,4.2,21.8,32.9,10.1-19.3C259.9,37,203,50.2,203,50.2s13.1,0,24.3,30.7 c11.2,30.7,40.3,34.2,43.1,39.5s5.7,18.3,2.7,35c-3,16.8,21.1-92.1,86.5-69.7"
}), React.createElement("path", {
  id: "XMLID_202_",
  className: "st4",
  d: "M268.1,195.1c0,0-5.6-47.5,29.6-77s84.1-18.4,84.1-18.4s-54.5-13.6-73.5,14.4 c-19,28-12.8-16.9-46.1,79.5c-16.6,48.2-6.8,25.7,1.4-12.8s15-93.1-7.9-108.9c-45.7-31.7-50.1-17.3-50.1-17.3s13.5-3.1,28.3,27.9 s41.8,45.1,41.8,45.1s20.6-30,1-52.4S244,33.8,206.9,49.4c0,0-13.5-12.1,5.2,10.9s37.9,48.7,51.9,56c14.1,7.4-15.6,18.5,28,0.1 s50.6-21.5,60.8-24.2c10.2-2.7,22.1,2.6,22.1,2.6s-41.7-24.3-68,9.5c-26.3,33.9-37.7,60.9-37.7,60.9S302,62.9,223.7,50.4"
}), React.createElement("path", {
  id: "XMLID_201_",
  className: "st3",
  d: "M257.5,206.1c0,0,3.3-14.4,9.4-33.5c12.1-37.6,35.4-93.2,67.1-93c0,0,29.2-3,38.5,8.5 s-21.3-32.2-52.6-9.5s-19.2,29.9-13.9,20.3s22.3-26.6,45.6-15.4"
}), React.createElement("path", {
  id: "XMLID_200_",
  className: "st3",
  d: "M267.3,175.9c0,0,65.9-123-49.2-130.3"
}), React.createElement("path", {
  id: "XMLID_199_",
  className: "st3",
  d: "M264.3,184.4c55.2-158.7-56.8-137.7-56.8-137.7s94.3-2.2,64.9,118.4"
}), React.createElement("path", {
  id: "XMLID_198_",
  className: "st3",
  d: "M228.8,51.4c0,0,84-5.9,40.6,120.4"
}), React.createElement("path", {
  id: "XMLID_197_",
  className: "st3",
  d: "M198,48.8c0,0,30.1,13.6,41.7,45.4s49.7,27.2,49.7,27.2"
}), React.createElement("path", {
  id: "XMLID_196_",
  className: "st3",
  d: "M297.7,118.1c0,0,29.9,15.7,50.2-11.4s31-8.6,31-8.6"
}), React.createElement("path", {
  id: "XMLID_195_",
  className: "st1",
  d: "M253.3,229c0,0,12.5-40.9,33.3-40c0,0,10-9.5,17.4-9.5l-0.7,2.8c0,0,11.7-4.3,21.4,2.2 c0,0-4.3,0.5-4.9,1.8c0,0,17.2,8.6,15.6,20.3c0,0-4.3-8.1-12.1-5.3c-7.8,2.9-24.4,9.3-35.4-6.7l-1.3-2.1c0,0-26.5,9.3-27.8,72.7"
}), React.createElement("path", {
  id: "XMLID_194_",
  className: "st2",
  d: "M247.8,232.4c0,0,14.6-42.2,35.1-43.2s15.3-5.8,20.4-7s19-1.7,26.3,11 c7.4,12.7,5.9,12.7,5.4,14.9c0,0,4.1-6.3-7.6-5.4c-11.7,0.9-20.7,8.1-34.2-2.5c-13.5-10.6-7.9-8.4-14,1 c-6.1,9.5-10.8,5.7-14.6,22.9s-8.3,27-9.1,36.6s3.7,20.8-0.8,9.6c-4.5-11.2-4.7-23-1.2-34.2c3.5-11.2,1.8-14.3,7.9-23 c6.1-8.7,0.1-6,11.8-15.1c11.7-9,11.9-13.8,20.2-14.5s6.6-5.7,12.3-5.1s9.6-1.7,17.9,4.3c8.3,6,10.8,9.5,13.5,16.7 c2.7,7.2-1,11.7-1,11.7s-1.8-13.6-22.1-9s-28.3-5.6-28.3-5.6s-14.8,7.4-21.9,22c-0.6,1.3-1.2,2.5-1.7,3.6 c-5.2,10.8-4.7,10.7-9,25.8c-4.7,16.7-5.7,27.2-5.7,29.5c0,2.3,4.4,12.2,4.7-7.5s7.8-32.5,7.8-32.5s-3-17.6,8.8-31.7 c11.8-14.1,43-34.7,61.2-8.2c0,0-43.8-30.8-68.4,29.5"
}), React.createElement("path", {
  id: "XMLID_193_",
  className: "st2",
  d: "M259.6,202.5c0,0,24-35.4,55.5-11.2"
}), React.createElement("path", {
  id: "XMLID_192_",
  className: "st2",
  d: "M323.4,201.3c-26.7,9.9-34.9-9.2-34.9-9.2"
}), React.createElement("path", {
  id: "XMLID_191_",
  className: "st2",
  d: "M292.2,194.1"
}), React.createElement("path", {
  id: "XMLID_190_",
  className: "st2",
  d: "M332.8,206.6c0,0-2.8-9.4-24.9-6"
}), React.createElement("path", {
  id: "XMLID_189_",
  className: "st2",
  d: "M308.2,179.2c0,0,25.9,3.6,29.5,28.6"
}), React.createElement("path", {
  id: "XMLID_188_",
  className: "st2",
  d: "M332.6,198.5c0,0-33.4-32.6-68.9,15.3"
}), React.createElement("path", {
  id: "XMLID_187_",
  className: "st2",
  d: "M331.4,200.3c0,0-44.4-39.1-73.6,37.8"
}), React.createElement("path", {
  id: "XMLID_186_",
  className: "st3",
  d: "M251.3,247.3c0,0,12.4-78.9,65.5-63"
}), React.createElement("path", {
  id: "XMLID_185_",
  className: "st3",
  d: "M335,201.3c0,0-14.1-25.9-48.3-12.3"
}), React.createElement("path", {
  id: "XMLID_184_",
  className: "st3",
  d: "M249.9,235.4c0,0,12.3-44.7,34.4-46.2"
}), React.createElement("path", {
  id: "XMLID_183_",
  className: "st3",
  d: "M286.3,186.2c0,0-21.9,6.2-33.1,45.8"
}), React.createElement("path", {
  id: "XMLID_182_",
  className: "st3",
  d: "M305.4,181.9c0,0,8.2-2.7,13.3,3.2"
}), React.createElement("path", {
  id: "XMLID_181_",
  className: "st2",
  d: "M295.2,181.5c0,0,23.3-10.4,37.1,14.8c14.3,26.2-59.2-6.8-59.2-6.8"
}), React.createElement("path", {
  id: "XMLID_180_",
  className: "st1",
  d: "M245,277.8c0,0,6-86.6,1.1-88.5c0,0-35.5-2.3-43.1-33.6c-7.6-31.3-8.6-42.4-28.6-38.3 c0,0,33-17.3,51.1,5.5c0,0,0.7-3.7,0.1-6.7c0,0,21.4,9.4,23.2,32.1c0,0,2.8-4.3,2.8-10.4c0,0,8.9,24-0.6,48.4 c0,0,11.5,59.1,9.4,84.7"
}), React.createElement("path", {
  id: "XMLID_179_",
  className: "st2",
  d: "M245.9,284.2c0,0,5.7-89.1-5.2-97.5c-10.9-8.4-25.3-6.4-37.6-31.1 c-12.2-24.6-9.3-38.7-28.6-38.3c-19.3,0.4,39.8-26.6,68.8,8.3s10,72.4,10,72.4s4.1,55.2,0.1,78.5"
}), React.createElement("path", {
  id: "XMLID_178_",
  className: "st2",
  d: "M242.3,277.7c0,0,12.4-83.7-1.6-91c-14.1-7.3-32.3-1-37.6-31.1c-5.3-30.1,9-67.5,30.5-34.5 c0.5,0.7,0.9,1.4,1.3,2c19.7,30.3,10,17.1,13.2,31.5c3.3,14.7-1.1,21.7,2.5,41.2c3.6,19.5,11.6,28.1,9.3,51.4 c-2.4,23.2-2.3,19.1-5-12.6s8.5-21.8-3.8-48.5c-12.4-26.6-0.6-48.5-14.8-54.2c-14.2-5.7-26.3-24.4-36.5-21 c-10.1,3.4-25.3,4.1-20.8,7.4s17.6,14.1,19.6,27.2c2,13.1,41.9,32.9,46.7,39.8c4.8,6.8-3.4,85.8-5.7,92.2"
}), React.createElement("path", {
  id: "XMLID_177_",
  className: "st3",
  d: "M167.1,118.3c0,0,1.3-0.2,3.6-0.4c8.6-0.6,30.6,0.4,40.2,23c12.2,28.4,7.9,36.4,22.3,45.6 c14.5,9.2,13.7,33.5,12,66.9s8.3-17.9,7.1-60.1s-0.9-109-83.9-75.2"
}), React.createElement("path", {
  id: "XMLID_176_",
  className: "st3",
  d: "M167.1,114.6c0,0,17.2-6,24.7,13.6c2.3,6.1,3.6,10.7,4.8,14.8c2.7,8.9,5.2,14.8,17.9,26.6 c1.1,1.1,2.2,2,3.1,2.8c14.6,12.1,9-3.5,21.2,19.8c13,24.8,15.2,18.4,13,42.2s-5.3,33.8-5.6,39.9c-0.3,6-4.6,7.5-4.9-8.2 s4.2-9.5,3.1-28.9s3.2-10.5-2.4-30c-5.6-19.5,2.6-6.1-9-20.5c-11.6-14.4-13.2-3.7-31.3-23.6c0,0-9.8-45.6-31.2-44.9"
}), React.createElement("path", {
  id: "XMLID_175_",
  className: "st2",
  d: "M183.4,113.8c0,0,21.6,1.3,36.4,26.3s4.9,2.8,19.2,34.7s18,30.2,17.8,62.3 c-0.1,32.1-7.2-63.1-22.1-85.3S197.3,112,183.4,113.8z"
}), React.createElement("path", {
  id: "XMLID_174_",
  className: "st4",
  d: "M215.1,135c16.1,34.2,41.3,80.3,40.2,78.1c-1.1-2.3,21.2-62.6-21.1-82s-25-22.6-63.4-20.4 c0,0,1.7,1.1,4.4,3.1c9.5,6.8,31.2,23.7,34.7,38.6c4.5,19.2-7,17,11.1,28.3s21.9,1.1,26,25.2c4.1,24.1,10.5,22.4,4.8,48.5 s-2.5,44.5,0.4,19.7s14.4,33,6.2-24.2c-8.2-57.2,5.5-72-5.2-101.5c-10.7-29.6-23.5-36.8-54.8-33.4"
}), React.createElement("path", {
  id: "XMLID_173_",
  className: "st5",
  d: "M259.8,281.8c0,0,21.2,3.8,27.8,1.7c6.5-2,1.5,4,16-1.8c14.5-5.8-1.9-7.7,25.8-10.7 c27.7-3,17.9-1.7,37-3.4c19.2-1.7-1.3-1.4,29.2-2.1"
}), React.createElement("path", {
  id: "XMLID_172_",
  className: "st5",
  d: "M290.6,277.7c0,0-59.1,12-93.6,6.7c-34.4-5.3-26.4-3.9-67.9-9.4c-41.5-5.4-41.5,1.6-60.5-3.7 c-3.9-1.1,1-3.8,45-0.3c44,3.5,16,1.5,43,4.9c27,3.4,29.5,3,62.2,5.5s17.9-4.6,53.5-5.6c35.6-1,14.8,0,27-2.5s33.9-5.4,50.3-4.5 c16.5,0.9,59.5-1.3,59.5-1.3"
}), React.createElement("path", {
  id: "XMLID_168_",
  className: "st6",
  d: "M268.4,274.1c53.9-4.2,47.2-5.4,73.7-3.5s-94.4,5.3-154.7,1.4c-60.3-3.9-37.7-1.2-68.3,0 c-30.6,1.3-132,10.5-26.5,4c105.5-6.5,71.9-2.9,125.2,2.2s13.6,10.5,65.4,6.1s31.9-10,80.6-10.9"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_nd_layer",
  className: "st0"
}, React.createElement("path", {
  id: "XMLID_167_",
  className: "st7",
  d: "M205.2,285.3c0,0-20.1-36-22.5-35.5c0,0-14.7,8.3-25.9-2.2c-11.1-10.5-14.4-14.6-21.3-7.8 c0,0,8.6-15.5,21.7-11.1c0,0-0.7-1.6-1.7-2.7c0,0,11-1.8,17.6,6.8c0,0,0-2.4-1.6-4.9c0,0,9.8,7.2,12.3,19.4 c0,0,19.9,20.5,25.7,31.3"
}), React.createElement("path", {
  id: "XMLID_166_",
  className: "st8",
  d: "M207.2,287.7c0,0-20.9-36.9-27.4-37.4s-11.7,4-23-2.6c-11.3-6.6-13.7-13-21.3-7.8 c-7.6,5.2,8.9-20.9,29.5-14.6c20.6,6.4,22.8,26.2,22.8,26.2s16,20.9,20.4,31.2"
}), React.createElement("path", {
  id: "XMLID_165_",
  className: "st8",
  d: "M204.1,286c0,0-16.8-36.5-24.3-35.8c-7.5,0.8-13.1,8-23-2.6c-9.9-10.6-13.9-29.2,3.2-21.6 c0.4,0.2,0.7,0.3,1.1,0.5c15.7,6.9,8.4,4.2,13.4,9.1c5.1,5,5.2,8.9,11.7,15.8c6.5,6.8,11.9,8.2,17,18c5.1,9.9,4,8.2-5.3-3.7 c-9.3-11.9-2.3-10.9-14.1-18.3c-11.8-7.4-12.9-19.1-20-17.7c-7.1,1.4-16.8-2.9-20,1.1s-9,8.2-6.3,8.3c2.7,0.1,10.7,1.1,14.8,5.7 s25.2,2.2,28.9,3.7c3.7,1.5,21,35,21.7,38.2"
}), React.createElement("path", {
  id: "XMLID_164_",
  className: "st9",
  d: "M132.8,242.1c0,0,0.5-0.4,1.3-1.1c3.3-2.5,12.3-7.8,22-1.3c12.2,8.2,12.6,12.4,20.7,12.3 c8.1-0.1,14.1,9.8,22.2,23.5s-1.3-9.3-12.8-25.8s-28.7-43.1-52.9-8.1"
}), React.createElement("path", {
  id: "XMLID_163_",
  className: "st9",
  d: "M131.8,240.6c0,0,5.3-6.9,13.4-1c2.5,1.8,4.2,3.3,5.8,4.6c3.4,2.8,5.9,4.6,14,5.9 c0.7,0.1,1.4,0.2,2,0.3c8.9,1,2.7-3.7,13.6,2.4c11.6,6.5,10.8,3.3,16.2,13.4s6.7,14.9,8.1,17.3s0.1,4.2-4.1-2s-0.8-4.9-6.3-12.3 c-5.5-7.4-1.4-5-8.7-11.3c-7.3-6.3-0.6-3.1-8.9-5.8c-8.4-2.7-6.2,2-18.6-1.3c0,0-15.7-15.6-24.1-9.8"
}), React.createElement("path", {
  id: "XMLID_162_",
  className: "st8",
  d: "M138.1,236.1c0,0,8.9-5.1,21.3,1s2.7-0.2,16.7,8.8s15,7.4,23.3,20.2 c8.3,12.8-19.3-23.2-31-28.2S143.2,231.8,138.1,236.1z"
}), React.createElement("path", {
  id: "XMLID_161_",
  className: "st10",
  d: "M156.2,236.3c15.3,9.4,37.3,21.2,36.3,20.6c-1-0.6-7.8-30.4-29.7-27.1 c-21.9,3.3-15.8-2.5-30.5,8.4c0,0,1,0,2.5,0.1c5.5,0.2,18.6,1.3,23.9,6.4c6.8,6.4,1.6,8.6,11.8,8.4c10.1-0.2,9-5.3,16.9,3.3 s10,6.2,14.5,18c4.5,11.9,10.5,18.3,5.3,7.8s14.3,9.4-3.8-11.2s-16.5-30.1-28.4-39c-11.9-9-18.9-8.5-30.5,0.9"
}), React.createElement("path", {
  id: "XMLID_160_",
  className: "st7",
  d: "M183.2,215.5c0,0-2.9-53.1-18.8-74.5c0,0-26.1,5.5-36.3-2.4s-20.4-34.3-38.3-22.6 c0,0,6.6-19.4,37.7-15.4c0,0-0.9-5.7-4-6.1c0,0,20,2.9,24.8,15.4c0,0,1.5-3.9-0.9-8.5c0,0,13.2,7.5,18.7,32.4 c0,0,9.2,15.7,10.1,20.4c0,0,1.7-23.5,6.2-28.9c0,0-3-25.3,5.9-31.7c0,0-1,5,0.4,8.3c0,0,4.7-18.5,18-20.9c0,0-2.5,3.8-2.2,5.8 c0,0,23.4-13.8,37.3,0.7c0,0-11.5-6.1-17.4,8.6s-7.3,32.2-35.9,31.6c0,0-2.7,1.3-3.3,5c-0.5,3.7-8.1,18.7,4.2,69.1"
}), React.createElement("path", {
  id: "XMLID_159_",
  className: "st8",
  d: "M189.6,213.2c0,0-16.2-67.7-0.9-83.9c0,0,9,3.5,20.7-10.6s14.9-39.6,23.6-36.8 s-31.3-12.4-44.8,11.6c-13.5,24-5.9,39.9-8.4,44.6c-2.5,4.7-7.8,18.7-4.5,30.4s17.9,62.7,12.6,42.3c-5.3-20.4-9.1-60.7-15.1-72 s-39-66.5-80.1-24.5c0,0,38.7-43.1,76,21s20.1,85.6,20.1,85.6s-13.3-70.3-6.2-90.4s-7.4-33.2,15.6-48.1s44,8.4,44,8.4 s-8.4-19-17.7,7.3c-9.3,26.3-21.9,29.6-36.3,29.5c-14.4-0.1-2.4,83.6-2.4,83.6s-12.2-61.8-21.6-70.2c-4.9-4.3-10.1-0.3-17.4,1 c-6.8,1.2-15.4,0-27.2-12.5C95.3,103.5,87,118,87,118s10-11.1,24.8,1.9s31.2,18.8,41.3,18.2c10-0.6,29,17.9,1-18.8 s-67.9-5.8-67.9-5.8s10.3-4.8,30.2,15.3s44.1,12.2,48.2,15.5c4.1,3.2,11.1,12.3,14.8,26.5s-16.8-80,42.7-86.1"
}), React.createElement("path", {
  id: "XMLID_158_",
  className: "st10",
  d: "M189.7,203.7c0,0-21.6-35.3-4.6-71.2s59.4-44.9,59.4-44.9s-47.7,9-52.5,37.9 s-16.2-8.6-7.4,79.2c4.4,43.9,3.9,22.7-3.5-10.6s-22-78.5-45.7-82.7c-47.4-8.3-45.6,4.5-45.6,4.5s9.4-7.3,32.3,11.7 s49.2,20.3,49.2,20.3s5.4-31-18.2-41.5s-40.6-20.6-64.2,5.1c0,0-15-4.7,8,6.7s47.4,24.5,61.1,25.2s-5.5,20.2,22-10.1s32-35.2,39-41 c7-5.8,18.3-6,18.3-6s-41.6-4-50,32.1c-8.4,36.1-7.6,61.5-7.6,61.5s-11.3-92.3-77.4-73.8"
}), React.createElement("path", {
  id: "XMLID_157_",
  className: "st9",
  d: "M185.3,216.3c0,0-2.7-12.5-4.7-29.7c-4.1-33.9-6-86.1,19-97.4c0,0,21.9-12.9,33.3-7.3 s-28.4-17.6-44.8,11.6s-4.2,30.4-3.6,21s7.9-29,30.3-28.6"
}), React.createElement("path", {
  id: "XMLID_156_",
  className: "st9",
  d: "M182.1,188.9c0,0,7.2-120.6-85.9-84.6"
}), React.createElement("path", {
  id: "XMLID_155_",
  className: "st9",
  d: "M182.9,196.7C168.7,52,88.3,109,88.3,109s73.3-35.9,93.9,69.5"
}), React.createElement("path", {
  id: "XMLID_154_",
  className: "st9",
  d: "M106.7,105c0,0,63.9-35.1,75.5,79.9"
}), React.createElement("path", {
  id: "XMLID_153_",
  className: "st9",
  d: "M81.6,114.2c0,0,28.6-0.2,49.3,20.6s48.9,3.4,48.9,3.4"
}), React.createElement("path", {
  id: "XMLID_152_",
  className: "st9",
  d: "M185,132.5c0,0,29.2,1.5,35.3-27.1c6.1-28.7,21.3-18,21.3-18"
}), React.createElement("path", {
  id: "XMLID_151_",
  className: "st7",
  d: "M190.4,235.7c0,0-5-36.6,11.7-43.5c0,0,4.4-11,10.2-13.7l0.5,2.4c0,0,7.6-7.6,17.6-6.1 c0,0-3.2,1.9-3.2,3.2c0,0,16.6,0.5,19.6,10.3c0,0-6.3-4.8-11.4,0.2c-5.1,5.1-15.8,16.1-30.3,7.6l-1.8-1.2c0,0-17.5,17,4.5,67.2"
}), React.createElement("path", {
  id: "XMLID_150_",
  className: "st8",
  d: "M187.3,240.4c0,0-3.8-38.4,11.9-46.6s9.9-10.1,13.5-12.9c3.6-2.7,14.3-8.2,24.7-0.9 c10.4,7.3,9.2,7.8,9.6,9.8c0,0,0.9-6.4-7.9-1.5s-13.3,13.8-27.8,10.4s-9.3-3.8-10.6,5.9s-6.5,8.4-3.2,23.3 c3.3,14.9,3.3,24.2,6.1,32.1c2.8,7.8,10.5,15,2.8,7.8c-7.6-7.2-12-16.3-13.4-26.4c-1.3-10.1-3.7-11.9-2.1-21s-2.1-4.8,3.8-16.1 c5.9-11.4,4.3-15.2,10.6-18.7s3.1-6.8,7.9-8.5c4.8-1.6,6.9-4.8,15.6-3.1s11.9,3.6,16.6,8.2c4.7,4.6,3.4,9.6,3.4,9.6s-6.3-10-20.7,1 c-14.3,11-24.3,5.9-24.3,5.9s-9,11.2-9.2,25.2c0,1.3,0,2.4-0.1,3.5c-0.1,10.4,0.2,10.1,2.3,23.6c2.3,14.8,5.4,23.5,6.2,25.3 s7.9,8,1-7.6c-6.9-15.6-5.7-28.4-5.7-28.4s-8.7-12.7-4.6-28.1s21.2-42.9,45.1-28.6c0,0-45.6-8.4-43,48"
}), React.createElement("path", {
  id: "XMLID_149_",
  className: "st8",
  d: "M185.7,212.6c0,0,6-36.5,39.6-28.9"
}), React.createElement("path", {
  id: "XMLID_148_",
  className: "st8",
  d: "M235.4,188.6c-17.4,17.4-30.8,5.4-30.8,5.4"
}), React.createElement("path", {
  id: "XMLID_147_",
  className: "st8",
  d: "M208.3,194.2"
}), React.createElement("path", {
  id: "XMLID_146_",
  className: "st8",
  d: "M244.7,189.3c0,0-5.6-6.4-21.8,4.3"
}), React.createElement("path", {
  id: "XMLID_145_",
  className: "st8",
  d: "M215.5,176.7c0,0,21.6-6.6,33.5,11.8"
}), React.createElement("path", {
  id: "XMLID_144_",
  className: "st8",
  d: "M241.6,183c0,0-38-13.5-48.6,37"
}), React.createElement("path", {
  id: "XMLID_143_",
  className: "st8",
  d: "M241.3,184.8c0,0-49-14.6-44.1,56.4"
}), React.createElement("path", {
  id: "XMLID_142_",
  className: "st9",
  d: "M195.4,250.8c0,0-18.8-66.5,28.6-73.2"
}), React.createElement("path", {
  id: "XMLID_141_",
  className: "st9",
  d: "M244.5,184.4c0,0-20.5-15.3-42.4,7.8"
}), React.createElement("path", {
  id: "XMLID_140_",
  className: "st9",
  d: "M190,242c0,0-6.6-39.6,10.3-48.8"
}), React.createElement("path", {
  id: "XMLID_139_",
  className: "st9",
  d: "M200.8,190.1c0,0-15,12.8-9.5,48"
}), React.createElement("path", {
  id: "XMLID_138_",
  className: "st9",
  d: "M214.2,179.9c0,0,5.4-5.1,11.6-2.3"
}), React.createElement("path", {
  id: "XMLID_130_",
  className: "st8",
  d: "M206.1,183.2c0,0,14.6-16.6,34.5-1.8c20.7,15.4-48.9,16.1-48.9,16.1"
}), React.createElement("path", {
  id: "XMLID_129_",
  className: "st7",
  d: "M201.5,277c0,0-26.7-70.2-31.2-69.9c0,0-28.7,11.1-46-10.8s-22.1-30.2-36.4-19.7 c0,0,19.6-25.6,42.1-14.2c0,0-0.8-3.1-2.4-5.3c0,0,20.2-0.3,29.9,16.8c0,0,0.6-4.3-1.5-9.2c0,0,15.7,15.6,17.1,38.2 c0,0,30.5,42.3,38.1,63.2"
}), React.createElement("path", {
  id: "XMLID_128_",
  className: "st8",
  d: "M204.5,281.8c0,0-27.8-72.1-39.4-74.7c-11.6-2.6-22.2,4.1-40.8-10.8 c-18.6-14.9-21.3-27-36.4-19.7c-15,7.3,21.6-35.4,57-18.4s34.1,53.3,34.1,53.3s23.2,41.9,28.5,61.7"
}), React.createElement("path", {
  id: "XMLID_127_",
  className: "st8",
  d: "M199.4,278c0,0-20.6-70.3-34.2-70.9c-13.7-0.6-25.7,10.9-40.8-10.8s-17.4-56.3,11.5-38.2 c0.6,0.4,1.2,0.8,1.8,1.1c26.5,16.7,14.1,9.8,21.8,19.9c7.9,10.4,7,17.5,16.9,31.5s19.3,17.9,25.9,37s5.1,15.8-8.5-8.1 c-13.6-23.9-1.2-20.2-20.6-36.7s-18.1-37.9-31.3-37.2c-13.2,0.7-29.5-9.6-36.3-3.3c-6.7,6.4-18.4,12.4-13.6,13.3 c4.8,1,18.9,4.7,25.2,14.3s44.9,10.7,51.1,14.4c6.2,3.6,28.5,68.7,28.9,74.6"
}), React.createElement("path", {
  id: "XMLID_126_",
  className: "st9",
  d: "M82.5,180c0,0,1-0.7,2.7-1.6c6.6-3.6,24.2-10.8,40,3.5c19.9,17.9,19.4,25.8,34,27.7 c14.7,2,22.9,21.4,33.7,48.3c10.8,26.9,0-17.1-16.2-49.9s-40.2-85.3-93.2-28.7"
}), React.createElement("path", {
  id: "XMLID_125_",
  className: "st9",
  d: "M81.2,177c0,0,11.4-11,24.3,1.7c4,3.9,6.7,7.1,9.2,9.9c5.4,6,9.4,9.8,23.7,14.4 c1.3,0.4,2.4,0.7,3.5,1c15.8,4.2,5.8-6,23.8,7.9c19.2,14.8,18.6,8.9,25.5,28.4c6.9,19.5,8.1,28.5,10,33.4c1.9,4.8-0.9,7.6-6.8-4.7 c-5.9-12.3-0.1-9-8.1-23.8c-7.9-14.8-1.3-9.4-12.7-22.7s-0.2-5.7-14.5-12.8c-14.3-7.1-11.7,1.9-33.2-7.2c0,0-24.2-32.3-40.8-24"
}), React.createElement("path", {
  id: "XMLID_124_",
  className: "st8",
  d: "M93.7,170.6c0,0,17.5-6.8,38.1,7.5c20.6,14.3,4.9,0.4,27.7,20.3s25.1,17.2,36.6,42.5 c11.5,25.3-28.5-47-48.3-59S104,164.1,93.7,170.6z"
}), React.createElement("path", {
  id: "XMLID_123_",
  className: "st10",
  d: "M126.3,175.7c25.1,21,61.6,48.2,59.9,46.8c-1.7-1.4-6-56.9-46.3-56.8s-27.8-8.7-57.3,6.9 c0,0,1.7,0.3,4.6,0.8c9.9,1.9,33.1,7.4,41.3,17.8c10.5,13.4,0.7,15.9,19,18.2c18.3,2.3,17.6-7.1,29.6,10.4 c12,17.5,16.4,13.8,21.4,36.4s14.1,35.8,7.4,15.4c-6.7-20.5,23.2,20.7-3.9-21.3s-21.7-58.5-40.9-77.9s-31.8-20.4-55.1-6.4"
}), React.createElement("path", {
  id: "XMLID_169_",
  className: "st5",
  d: "M200.3,271.2c0,0-21.2-3.8-27.8-1.8c-6.5,2-1.5-4-16,1.8c-14.5,5.8,1.9,7.7-25.8,10.7 c-27.7,3-17.9,1.7-37,3.4c-19.2,1.7,1.3,1.4-29.2,2.1"
}), React.createElement("path", {
  id: "XMLID_171_",
  className: "st5",
  d: "M169.5,275.3c0,0,59.1-12,93.6-6.7s26.4,3.9,67.9,9.4c41.5,5.4,41.5-1.6,60.5,3.7 c3.9,1.1-1,3.8-45,0.3c-44-3.5-16-1.5-43-4.9s-29.5-3-62.2-5.5s-17.9,4.6-53.5,5.5s-14.8,0-27,2.5c-12.1,2.6-33.9,5.4-50.3,4.5 S51,285.3,51,285.3"
}), React.createElement("path", {
  id: "XMLID_170_",
  className: "st6",
  d: "M191.7,278.9c-53.9,4.2-47.2,5.4-73.7,3.5c-26.5-1.9,94.4-5.3,154.7-1.3 c60.3,3.9,37.7,1.2,68.3,0s132-10.5,26.5-4s-71.9,2.9-125.2-2.3s-13.6-10.5-65.4-6.1s-31.9,10-80.6,10.9"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x34_"
}, React.createElement("path", {
  id: "XMLID_7_",
  className: "st11",
  d: "M228.2,281.7c0,0-9.1-28.2-10.9-28.2c0,0-11.5,3.8-17.9-5.2c-6.4-9-8.1-12.3-13.9-8.5 c0,0,8.2-9.7,16.9-4.7c0,0-0.3-1.2-0.8-2.1c0,0,8,0.3,11.4,7.2c0,0,0.3-1.7-0.4-3.7c0,0,5.9,6.5,6,15.4c0,0,11.2,17.3,13.7,25.7"
}), React.createElement("path", {
  id: "XMLID_6_",
  className: "st12",
  d: "M229.3,283.6c0,0-9.5-29-14-30.2c-4.5-1.3-8.8,1.2-15.9-5.1s-7.9-11.1-13.9-8.5 c-6.1,2.6,9.2-13.5,22.8-6.1c13.6,7.4,12.4,21.7,12.4,21.7s8.3,17,10,24.9"
}), React.createElement("path", {
  id: "XMLID_5_",
  className: "st12",
  d: "M227.3,282c0,0-6.7-28.1-12.1-28.6c-5.4-0.5-10.4,3.8-15.9-5.1c-5.5-8.9-5.7-22.5,5.3-14.8 c0.2,0.2,0.5,0.3,0.7,0.5c10.1,7.1,5.3,4.1,8.2,8.3c2.9,4.3,2.4,7,6,12.8c3.6,5.7,7.3,7.4,9.5,15.1c2.2,7.7,1.7,6.3-3.2-3.4 c-4.9-9.7-0.1-8-7.4-14.9c-7.3-6.9-6.4-15.3-11.6-15.3c-5.2,0-11.4-4.4-14.2-2c-2.8,2.4-7.5,4.5-5.6,5c1.9,0.5,7.4,2.3,9.7,6.1 c2.3,3.9,17.5,5.1,19.8,6.7c2.4,1.6,9.8,27.6,9.9,30"
}), React.createElement("path", {
  id: "XMLID_4_",
  className: "st13",
  d: "M183.2,241.1c0,0,0.4-0.2,1.1-0.6c2.7-1.3,9.7-3.8,15.7,2.2c7.5,7.5,7.1,10.5,12.9,11.6 s8.6,8.9,12.3,19.7c3.7,10.8,0.4-6.7-5.4-20c-5.7-13.2-14.1-34.4-36.2-13.2"
}), React.createElement("path", {
  id: "XMLID_3_",
  className: "st13",
  d: "M182.8,239.9c0,0,4.7-4.1,9.6,1.2c1.5,1.6,2.5,2.9,3.4,4.1c2,2.5,3.5,4,9.1,6.1 c0.5,0.2,0.9,0.3,1.3,0.5c6.2,2,2.4-2.2,9.2,3.6c7.3,6.2,7.2,3.9,9.5,11.7c2.3,7.8,2.6,11.4,3.3,13.3s-0.5,3-2.6-2s0.1-3.6-2.7-9.6 c-2.8-6-0.3-3.7-4.6-9.2s0-2.3-5.5-5.4c-5.5-3.1-4.6,0.5-12.9-3.5c0,0-8.9-13.2-15.6-10.3"
}), React.createElement("path", {
  id: "XMLID_2_",
  className: "st12",
  d: "M187.8,237.6c0,0,7-2.3,14.9,3.7c7.8,6,1.9,0.3,10.5,8.6c8.6,8.3,9.5,7.3,13.6,17.5 c4,10.2-10.3-19.1-17.8-24.2C201.4,237.9,192,235.2,187.8,237.6z"
}), React.createElement("path", {
  id: "XMLID_1_",
  className: "st14",
  d: "M200.6,240.3c9.5,8.8,23.3,20.2,22.7,19.6c-0.6-0.6-1.2-22.5-17.1-23.3 c-15.9-0.8-10.8-4-22.7,1.6c0,0,0.7,0.1,1.8,0.4c3.9,0.9,12.9,3.6,15.9,7.8c3.9,5.5-0.1,6.3,7.1,7.6c7.2,1.3,7.1-2.4,11.5,4.7 c4.4,7.1,6.2,5.8,7.7,14.8c1.5,9,4.9,14.4,2.6,6.2c-2.2-8.2,8.7,8.6-1.1-8.5s-7.4-23.5-14.5-31.5c-7.2-8-12.1-8.7-21.6-3.6"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x33_"
}, React.createElement("path", {
  id: "XMLID_98_",
  className: "st11",
  d: "M222.5,229.4c0,0,5.5-37.8-2.8-55.2c0,0-19.2,0.2-25.3-6.8s-9.5-27.1-23.8-21.3 c0,0,7.4-12.7,28.8-5.6c0,0,0.2-4.1-1.9-4.8c0,0,13.7,4.8,15.3,14.3c0,0,1.6-2.5,0.5-6.1c0,0,8.3,7.2,8.6,25.4 c0,0,4.2,12.4,4.3,15.8c0,0,4.5-16.3,8.4-19.5c0,0,1.4-18.3,8.6-21.5c0,0-1.4,3.4-0.9,5.9c0,0,5.9-12.4,15.6-12.2 c0,0-2.3,2.3-2.3,3.8c0,0,18.5-6.5,26.2,5.7c0,0-7.3-5.9-13.5,3.6c-6.2,9.5-9.7,21.7-29.7,17.2c0,0-2.1,0.5-3,3 c-0.9,2.5-8.3,12-6.7,49.3"
}), React.createElement("path", {
  id: "XMLID_101_",
  className: "st12",
  d: "M227.3,228.6c0,0-1.9-50,11.2-59.3c0,0,5.9,3.7,16.1-4.5c10.2-8.3,16.1-25.8,21.8-22.6 c5.7,3.2-20.3-13.1-33.2,1.9c-12.9,15-9.8,27.3-12.2,30.3c-2.4,3-8.1,12.1-7.4,20.8s3.8,46.7,2.9,31.6s2.1-44-0.5-52.9 c-2.7-8.8-18.1-52.4-53-28.6c0,0,33.3-24.9,50.6,25.5s2.2,63.1,2.2,63.1s0.5-51.4,8.4-64.6c7.9-13.1-0.6-24.4,17.7-31.7 c18.3-7.2,29.9,12.1,29.9,12.1s-3.3-14.6-13.5,2.6c-10.2,17.2-19.6,17.8-29.7,15.7c-10.1-2.1-13.4,58.6-13.4,58.6 s0.1-45.3-5.4-52.5c-2.8-3.7-7.1-1.6-12.4-1.8c-5-0.1-10.9-2.2-17.4-12.6c-13.6-21.7-21.5-12.7-21.5-12.7s8.6-6.4,17.2,4.8 c8.6,11.2,19.4,17.7,26.5,18.6c7.2,1,17.9,16.7,3.3-13.1s-47.1-13.6-47.1-13.6s7.9-1.9,19.1,15.1c11.2,17,29.3,14.8,31.8,17.7 c2.4,2.8,6.1,10.2,6.7,20.8c0.6,10.6-0.6-58.8,42.2-54.7"
}), React.createElement("path", {
  id: "XMLID_132_",
  className: "st14",
  d: "M228.7,222c0,0-10.3-27.9,6.7-50.8s48.2-23.3,48.2-23.3s-34.9-0.4-42.4,19.4 c-7.4,19.7-10.2-8.4-16.4,54.8c-3.1,31.6-0.4,16.5-1-8s-4.4-58.4-20.5-64.7c-32.3-12.5-32.8-3.2-32.8-3.2s7.7-3.8,21.1,12.8 s31.8,21.2,31.8,21.2s8.1-21.1-7-31.8c-15.2-10.7-25.7-20.3-46-5.5c0,0-9.9-5.4,4.7,5.8c14.6,11.2,30,24,39.5,26.4 c9.6,2.4-6.7,13.4,17-4s27.5-20.3,33.3-23.4c5.8-3.1,13.7-1.6,13.7-1.6s-28.7-8.7-39.7,15.6c-11,24.3-14,42.3-14,42.3 s5-66.6-44.1-62.9"
}), React.createElement("path", {
  id: "XMLID_131_",
  className: "st13",
  d: "M223.9,230.2c0,0-0.1-9.2,0.8-21.6c1.9-24.5,7.9-61.5,27.1-65.9c0,0,17.2-6,24.5-0.4 c7.3,5.6-17.5-16.4-33.2,1.9s-7.3,20.9-5.5,14.3c1.8-6.6,9.7-19.3,25.4-15.9"
}), React.createElement("path", {
  id: "XMLID_134_",
  className: "st13",
  d: "M225.5,210.5c0,0,22.1-84-48.6-71.7"
}), React.createElement("path", {
  id: "XMLID_135_",
  className: "st13",
  d: "M224.9,216.1c10.4-103.9-54.3-75.1-54.3-75.1s56.7-15,56.4,62.2"
}), React.createElement("path", {
  id: "XMLID_136_",
  className: "st13",
  d: "M184.2,140.8c0,0,49.9-15.8,42,66.9"
}), React.createElement("path", {
  id: "XMLID_133_",
  className: "st13",
  d: "M165.2,143.7c0,0,20.2,3.9,31.8,21.4c11.6,17.6,34,9.3,34,9.3"
}), React.createElement("path", {
  id: "XMLID_137_",
  className: "st13",
  d: "M235.5,171.2c0,0,20.4,5.2,28.7-14.2c8.3-19.3,17.5-9.7,17.5-9.7"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x32_"
}, React.createElement("path", {
  id: "XMLID_25_",
  className: "st11",
  d: "M224.7,244.6c0,0,1.6-26.5,14.3-29c0,0,4.7-7.2,9.1-8.2v1.8c0,0,6.5-4.3,13.3-1.8 c0,0-2.5,0.9-2.7,1.8c0,0,11.6,2.7,12.4,10c0,0-3.8-4.3-8.1-1.4c-4.3,2.9-13.4,9.1-22.4,1.1l-1.1-1.1c0,0-14.7,9.5-6.3,48"
}), React.createElement("path", {
  id: "XMLID_24_",
  className: "st12",
  d: "M221.9,247.5c0,0,2.7-27.6,15-31.2c12.2-3.6,8.4-5.7,11.3-7.2c2.9-1.4,11.2-3.8,17.5,2.9 c6.3,6.6,5.4,6.8,5.4,8.3c0,0,1.6-4.4-5.4-2.2s-11.3,7.9-21.1,3.4c-9.7-4.4-6-4-8.3,2.7c-2.3,6.6-5.7,5-5.5,16 c0.2,11-1.1,17.5-0.2,23.4c0.9,5.9,5.3,12,0.9,5.9c-4.4-6.1-6.2-13.2-5.7-20.5c0.5-7.3-1-8.9,1.5-15.1c2.4-6.2-0.8-3.7,4.9-10.8 c5.8-7.2,5.2-10.1,10.1-11.7s3.1-4.4,6.7-4.9c3.6-0.5,5.6-2.4,11.5,0c5.9,2.4,7.9,4.2,10.6,8.1c2.7,3.9,1.1,7.2,1.1,7.2 s-3-8-14.7-2.2c-11.6,5.7-17.9,0.7-17.9,0.7s-7.9,6.6-10,16.5c-0.2,0.9-0.4,1.7-0.5,2.4c-1.6,7.3-1.3,7.1-1.7,16.9 c-0.5,10.8,0.5,17.3,0.8,18.7c0.3,1.4,4.4,6.7,1.8-5.2s0-20.8,0-20.8s-4.4-10.2,0.7-20.4c5.1-10.2,21-27.2,35.8-13.8 c0,0-30.9-12.3-37.1,27.8"
}), React.createElement("path", {
  id: "XMLID_23_",
  className: "st12",
  d: "M224.6,227.7c0,0,9.4-24.9,32-14.8"
}), React.createElement("path", {
  id: "XMLID_22_",
  className: "st12",
  d: "M263.1,217.8c-14.7,9.9-22.4-0.5-22.4-0.5"
}), React.createElement("path", {
  id: "XMLID_21_",
  className: "st12",
  d: "M243.2,217.9"
}), React.createElement("path", {
  id: "XMLID_20_",
  className: "st12",
  d: "M269.5,219.6c0,0-3-5.3-15.9,0"
}), React.createElement("path", {
  id: "XMLID_19_",
  className: "st12",
  d: "M250.7,206.6c0,0,16.2-1.6,22,13"
}), React.createElement("path", {
  id: "XMLID_18_",
  className: "st12",
  d: "M268.2,214.7c0,0-24.9-14.9-39.5,19.2"
}), React.createElement("path", {
  id: "XMLID_17_",
  className: "st12",
  d: "M267.8,216c0,0-32.5-17.2-39,33.5"
}), React.createElement("path", {
  id: "XMLID_16_",
  className: "st13",
  d: "M226.1,256c0,0-3.9-49.5,30.5-47.6"
}), React.createElement("path", {
  id: "XMLID_15_",
  className: "st13",
  d: "M270.1,216.1c0,0-12.3-13.6-31-0.5"
}), React.createElement("path", {
  id: "XMLID_14_",
  className: "st13",
  d: "M223.6,249c0,0,0.9-28.8,14.1-32.9"
}), React.createElement("path", {
  id: "XMLID_13_",
  className: "st13",
  d: "M238.5,214c0,0-12.4,6.9-13.4,32.5"
}), React.createElement("path", {
  id: "XMLID_12_",
  className: "st13",
  d: "M249.4,208.6c0,0,4.5-2.8,8.5,0"
}), React.createElement("path", {
  id: "XMLID_11_",
  className: "st12",
  d: "M243.2,209.9c0,0,12.6-9.7,24.6,3.6c12.4,13.8-36.8,4.5-36.8,4.5"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "_x31_"
}, React.createElement("path", {
  id: "XMLID_107_",
  className: "st11",
  d: "M226.8,275.3c0,0-8.9-53.2-12.1-53.7c0,0-21.8,3.8-30.9-14.1c-9.1-17.8-11.4-24.4-22.8-19 c0,0,17.4-15.3,31.7-4c0,0-0.1-2.3-0.9-4.1c0,0,14.3,2.6,18.7,16.1c0,0,1.1-3,0.2-6.7c0,0,8.8,13.2,6.6,29.3 c0,0,15.5,34.1,17.9,49.9"
}), React.createElement("path", {
  id: "XMLID_108_",
  className: "st12",
  d: "M228.2,279.1c0,0-9.5-54.7-17.3-58.2c-7.8-3.5-16.2-0.2-27.2-13.3s-11.2-22.1-22.8-19 s20.2-21.9,42.8-5s16.5,42.3,16.5,42.3s10.5,32.8,11.4,47.5"
}), React.createElement("path", {
  id: "XMLID_110_",
  className: "st12",
  d: "M225.1,275.7c0,0-4.6-52.4-14.2-54.8c-9.6-2.4-19.7,4.1-27.2-13.3s-4.3-42.1,13.4-25.3 c0.4,0.4,0.7,0.7,1.1,1c16.3,15.5,8.5,8.9,12.6,17.1c4.1,8.4,2.5,13.3,7.5,24.6s11.1,15.3,13,29.7c1.9,14.4,1.4,11.9-4.8-6.9 s2-14.4-9.3-28.8s-7.4-29.3-16.8-30.7c-9.4-1.4-19.5-10.9-25.1-7.4c-5.6,3.5-14.7,6.1-11.5,7.5c3.2,1.3,12.7,6,15.8,13.6 c3.1,7.6,30.1,13.9,34,17.3c3.9,3.4,10.4,52.4,9.9,56.6"
}), React.createElement("path", {
  id: "XMLID_111_",
  className: "st13",
  d: "M156.5,190.2c0,0,0.8-0.3,2.1-0.8c5.1-1.6,18.6-4.2,27.7,8.1c11.5,15.4,10,20.9,20.1,24.3 s13.1,18.3,17,38.8c3.8,20.5,2.4-12-4.4-37.4s-16.3-65.8-61.7-33.4"
}), React.createElement("path", {
  id: "XMLID_109_",
  className: "st13",
  d: "M156,187.9c0,0,9.6-6.1,16.9,4.6c2.3,3.3,3.7,6,5.1,8.2c2.9,5,5.3,8.2,14.7,13.5 c0.8,0.5,1.6,0.9,2.3,1.2c10.6,5.2,4.9-3.4,15.7,8.9c11.5,13.1,11.9,8.9,14,23.6c2.1,14.7,1.7,21.2,2.4,24.9s-1.7,5.2-4.1-4.2 s1.2-6.4-2.3-17.9c-3.5-11.6,0.4-6.8-5.8-17.8c-6.2-11,0.7-4.1-8.4-11.1c-9.1-7-8.5-0.3-22.4-9.8c0,0-12.5-26.2-25.4-22.7"
}), React.createElement("path", {
  id: "XMLID_114_",
  className: "st12",
  d: "M165.7,185.1c0,0,13.3-2.3,25.8,10.6c12.5,13,3.4,1,16.6,18.2s15.2,15.7,19.8,35.1 s-13.5-37.1-25.7-48.4C190,189.4,173.9,182,165.7,185.1z"
}), React.createElement("path", {
  id: "XMLID_115_",
  className: "st14",
  d: "M188,193.4c14.7,18.3,36.6,42.6,35.6,41.4c-1-1.2,3.8-40.9-24.6-46.5 c-28.4-5.6-18.4-10-41.3-3.2c0,0,1.2,0.4,3.1,1.2c6.7,2.7,22.3,9.8,26.6,18.3c5.5,10.9-1.8,11.3,10.8,15.5 c12.6,4.2,13.4-2.5,19.4,11.5c6,14,9.6,12,9.9,28.6c0.3,16.6,4.9,27.3,3.1,11.9c-1.8-15.4,13.5,17.8,0.2-15.5 c-13.3-33.4-7.1-44.3-17.8-60.6s-19.5-18.9-38-12.3"
}));

var SvgPlant1 = function SvgPlant1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "plant1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458 340",
    style: {
      enableBackground: "new 0 0 458 340"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlant1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plant 1.23caddde.svg";
export { ForwardRef as ReactComponent };